<!-- 
    INFO:
    In Angular, $event is a special keyword that represents the event object
    emitted from a child component or DOM event. It allows data to be passed
    to the parent component when an event is triggered.
-->

<div *ngIf="IsDragNDrop; else buttonTemplate">
  <div
    class="!p-[1.2rem] !pb-0 !pt-0  items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
  >
    <label *ngIf="label">
      {{ label }}
    </label>
    <div class="">
      <app-drag-and-drop-file-upload
        (filesSelectedEvent)="onFilesSelected($event)"
      ></app-drag-and-drop-file-upload>
      <app-new-files
        [files]="newFiles"
        (removeNewFile)="onRemoveNewFile($event)"
      ></app-new-files>
      <app-old-files
        [oldFiles]="oldFiles"
        (removeOldFile)="onRemoveOldFile($event)"
      ></app-old-files>
    </div>
  </div>
</div>

<ng-template #buttonTemplate>
  <div>
    <app-file-upload
      [label]="label"
      (filesSelectedEvent)="onFilesSelected($event)"
    ></app-file-upload>
    <app-new-files
      [files]="newFiles"
      (removeNewFile)="onRemoveNewFile($event)"
    ></app-new-files>
    <app-old-files
      [oldFiles]="oldFiles"
      (removeOldFile)="onRemoveOldFile($event)"
    ></app-old-files>
  </div>
</ng-template>
